import { render, staticRenderFns } from "./ShortLinkScreen.vue?vue&type=template&id=6edd6e44&scoped=true&"
import script from "./ShortLinkScreen.vue?vue&type=script&lang=js&"
export * from "./ShortLinkScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edd6e44",
  null
  
)

export default component.exports